import { render, staticRenderFns } from "./PortfolioUploadOverview.vue?vue&type=template&id=1254c894&scoped=true&"
import script from "./PortfolioUploadOverview.vue?vue&type=script&lang=js&"
export * from "./PortfolioUploadOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1254c894",
  null
  
)

export default component.exports